<template>
  <BModal
      centered
      scrollable
      :title="dialogTitle"
      :id="dialogId"
      :ok-title="okTitle"
      :cancel-title="cancelTitle"
      :cancel-variant="cancelVariant"
      :ok-disabled="isOkDisabled"
      :ok-only="okOnly"
      :no-close-on-backdrop="noCloseOnBackdrop"
      @ok.prevent="emitOkay"
      @close="emitClose"
      header-bg-variant="success"
      title-class="text-white"
      ok-variant="success"
      :dialog-class="modalClass"
  >
    <BContainer fluid class="custom-modal-container custom-scrollbar">
      <BFormRow>
        <slot></slot>
      </BFormRow>
    </BContainer>
  </BModal>
</template>

<script>
export default {
  emits: ["ok", "close"],
  props: {
    dialogId: {
      type: String,
      required: false,
      default: "custom-create-dialog",
    },
    dialogTitle: {
      type: String,
      required: true,
    },
    okOnly: {
      type: Boolean,
      default: false,
      required: false,
    },
    okTitle: {
      type: String,
      default: "ایجاد",
    },
    cancelTitle: {
      type: String,
      default: "بستن",
    },
    cancelVariant: {
      type: String,
      default: "",
    },
    noCloseOnBackdrop: {
      type: Boolean,
      default: false,
    },
    isOkDisabled: {
      type: Boolean,
      default: false,
    },
    width: {
      type: String,
      default: "500px"
    },
    maxWidth: {
      type: String,
      default: "90%"
    },
    minWidth: {
      type: String,
      default: "300px"
    }
  },
  computed: {
    modalClass() {
      return "custom-modal-dialog";
    }
  },
  mounted() {
    this.addDynamicStyles();
  },
  updated() {
    this.addDynamicStyles();
  },
  methods: {
    emitOkay() {
      this.$emit("ok");
    },
    emitClose() {
      this.$emit("close");
    },
    addDynamicStyles() {
      const styleId = `modal-style-${this.dialogId}`;
      let style = document.getElementById(styleId);

      if (!style) {
        style = document.createElement('style');
        style.id = styleId;
        document.head.appendChild(style);
      }

      style.textContent = `
        .custom-modal-dialog {
          width: ${this.width} !important;
          max-width: ${this.maxWidth} !important;
          min-width: ${this.minWidth} !important;
        }

        @media only screen and (max-width: 768px) {
          .custom-modal-dialog {
            width: 95% !important;
            max-width: 95% !important;
          }
        }
      `;
    }
  },
  components: {
    BModal,
    BContainer,
    BFormRow,
  },
};
import { BModal, BContainer, BFormRow } from "bootstrap-vue";
</script>

<style scoped>
.custom-modal-container {
  max-height: 700px;
  overflow-y: auto;
}

@media only screen and (max-width: 768px) {
  .custom-modal-container {
    max-height: 500px !important;
  }
}
</style>